import { useRehabQuestion2 } from 'contexts/AuthContext'
import _ from 'lodash'

export const useSkuCondition = () => {
  const { rehabQuestion2 } = useRehabQuestion2()

  const updateSkuPrimary = ({ skuCondition, themeIds, newQuestionId, sku }) => {
    const themeIdArray = Array.isArray(themeIds) ? themeIds : [themeIds]

    const updatedSkuPrimary = []
    const processedThemeIds = new Set()

    skuCondition?.[`${sku}_primary`]?.forEach((item) => {
      const [tId] = item?.split('^')
      const tIdStr = tId?.toString()

      if (themeIdArray.some((id) => id?.toString() === tIdStr)) {
        updatedSkuPrimary.push(`${tId}^${newQuestionId}`)
        processedThemeIds.add(tIdStr)
      } else {
        updatedSkuPrimary.push(item)
      }
    })

    themeIdArray.forEach((id) => {
      const idStr = id?.toString()
      if (!processedThemeIds.has(idStr)) {
        updatedSkuPrimary.push(`${id}^${newQuestionId}`)
      }
    })

    return updatedSkuPrimary
  }

  const getNewSkuCondition = ({ skuCondition, themeIds, sku }) => {
    let _skuCondition = {}
    if (
      ((sku === 'msk' || sku === 'pt') && !_.isEmpty(rehabQuestion2)) ||
      sku === 'mca'
    ) {
      _skuCondition = {
        skuPrimary: updateSkuPrimary({
          skuCondition,
          themeIds,
          newQuestionId: sku === 'mca' ? 1 : rehabQuestion2.id,
          sku: sku === 'mca' ? 'msk' : sku,
        }),
        sku: sku === 'mca' ? 'msk' : sku,
        ...(skuCondition?.msk_primary_other && {
          skuPrimaryOther: skuCondition?.msk_primary_other,
        }),
      }
    } else if (sku === 'wlc') {
      _skuCondition = {
        ...(skuCondition?.wlc_primary && {
          skuPrimary: skuCondition?.wlc_primary,
        }),
        ...(sku && { sku }),
        ...(skuCondition?.wlc_primary_other && {
          skuPrimaryOther: skuCondition?.wlc_primary_other,
        }),
      }
    } else if (sku === 'rd') {
      _skuCondition = {
        ...(skuCondition?.rd_primary && {
          skuPrimary: skuCondition?.rd_primary,
        }),
        ...(sku && { sku }),
        ...(skuCondition?.rd_primary_other && {
          skuPrimaryOther: skuCondition?.rd_primary_other,
        }),
        ...(skuCondition?.rd_secondary && {
          skuSecondary: skuCondition?.rd_secondary,
        }),
        ...(skuCondition?.rd_secondary_other && {
          skuSecondaryOther: skuCondition?.rd_secondary_other,
        }),
      }
    } else {
      _skuCondition = {
        ...(skuCondition?.msk_primary && {
          skuPrimary: skuCondition?.msk_primary,
        }),
        ...(sku && { sku }),
        ...(skuCondition?.msk_primary_other && {
          skuPrimaryOther: skuCondition?.msk_primary_other,
        }),
      }
    }
    console.log('getSkuCondition', _skuCondition)
    return _skuCondition
  }

  return { getNewSkuCondition }
}
